import React from "react";
import { components, GroupBase, NoticeProps } from "react-select";

const { NoOptionsMessage } = components;

export function CustomNoOptionsMessage<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: NoticeProps<Option, IsMulti, Group>) {
  const { testIdKey } = props.selectProps ?? {};

  return (
    <div data-testid={`${testIdKey}_field_no_options`}>
      <NoOptionsMessage {...props}>{"No Options"}</NoOptionsMessage>
    </div>
  );
}
